import algoliasearch from "algoliasearch/lite";
import instantsearch from "instantsearch.js";
import { configure, hits, searchBox, index } from "instantsearch.js/es/widgets";

const bodyLocale = document.getElementsByTagName("BODY")[0].dataset.shopLocale;

const locale = bodyLocale === "da" ? "" : bodyLocale + "_";

function isMobileDevice() {
  if (
    /Android|webOS|iPhone|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return true;
  }

  return false;
}

const searcBox = isMobileDevice() ? "mobile-searchbox" : "desktop-searchbox";
const searcResultsContainer = isMobileDevice() ? "mobile-hits" : "desktop-hits";

const algoliaClient = algoliasearch(
  "HZZ25JRCSO",
  "c46fe3c12f9c8031192bfc2a2416191e"
);

const searchClient = {
  ...algoliaClient,
  search(requests) {
    if (requests.every(({ params }) => !params.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
        })),
      });
    }

    return algoliaClient.search(requests);
  },
};

const search = instantsearch({
  indexName: locale + "shopify_moodings_products",
  searchClient,
  searchFunction(helper) {
    const container = document.querySelector(
      "." + searcResultsContainer + "-container"
    );
    container.style.display = helper.state.query === "" ? "none" : "";
    document.getElementById(
      searcResultsContainer + "-products-see-all-button"
    ).href = "/search?q=" + helper.state.query;

    helper.search();
    if (helper.state.query === "") {
      document.getElementById("search-overlay").style.display = "none";
    } else {
      document.getElementById("search-overlay").style.display = "block";
    }
    document.querySelector(".ais-SearchBox-input").onkeydown = function (e) {
      if (e.keyCode == 13) {
        window.location.href = "/search?q=" + helper.state.query;
      }
    };
  },
});

const searchPlaceholder =
  document.getElementById("search-input-placeholder") != null
    ? document.getElementById("search-input-placeholder").innerText
    : "";

search.addWidgets([
  configure({
    hitsPerPage: 8,
  }),
  searchBox({
    container: "#" + searcBox,
    placeholder: searchPlaceholder,
  }),
  hits({
    container: "." + searcResultsContainer + "-products",
    templates: {
      item: function (item) {
        return `
                <a href="/products/${item.handle}">
                <div style="display:flex;  align-items: center;">                        
                    <div class="search-results-product-image">
                        <img src="${item.product_image}" alt="${item.title}" style="width:100%;">
                    </div>
                    <div>
                        <div class="hits-products-item-title">${item.title}</div>
                        <div class="hits-products-item-description">${item.product_type} <span class="hits-products-item-divider">|</span> ${item.vendor}</div>                        
                    </div>
                </div>
                </a>
            `;
      },
    },
  }),

  index({ indexName: locale + "shopify_moodings_collections" }).addWidgets([
    hits({
      container: "." + searcResultsContainer + "-collections",
      templates: {
        item: function (item) {
          const title = item.title.replace(" - ", " ");
          return `<a href="/collections/${item.handle}">
                    <div style="display:flex">                        
                    ${title}
                    </div>
                </a>`;
        },
      },
    }),
  ]),
]);

search.start();

const close = document.getElementById("search-overlay");

close.addEventListener("click", function () {
  search.helper.setQuery("").search();
});
